import script from "./modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./modal.vue?vue&type=script&lang=ts&setup=true"

import "./modal.vue?vue&type=style&index=0&id=08d6d5bd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d6d5bd"]])

export default __exports__